import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DigitalServicesService {
    constructor(private http: HttpClient) {}

    getAll(options: any = {}): Observable<any> {
        return this.http.post(
            `${environment.apiUrl}digital-service/all`,
            options,
        );
    }

    getList(options: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}digital-service`, options);
    }

    getById(id: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}digital-service/view/${id}`);
    }

    create(data: any): Observable<any> {
        return this.http.post(
            `${environment.apiUrl}digital-service/create`,
            data,
        );
    }

    update(id: string, data: any): Observable<any> {
        return this.http.put(
            `${environment.apiUrl}digital-service/update/${id}`,
            data,
        );
    }

    delete(id: string): Observable<any> {
        return this.http.delete(
            `${environment.apiUrl}digital-service/delete/${id}`,
        );
    }
}
